import React from 'react';
import {
  CheckCircleIcon,
  ClockIcon,
  TruckIcon,
  XCircleIcon,
} from '@heroicons/react/outline';
import Button from '../../../components/common/Button';

// ✅ FIXED: "Mark as Delivered" button logic
const QuickActionsBar = ({
  order,
  paymentStatus,
  onUpdateStatus,
  onUpdatePayment,
  formatCurrency,
}) => {
  const canConfirm = order.status === "PENDING";
  const canProcess = order.status === "CONFIRMED";
  const canMarkReady = order.status === "PROCESSING";
  const canDispatch =
    order.status === "READY" && order.fulfillment?.type === "DELIVERY";
  const canDeliver = order.status === "READY" || order.status === "DISPATCHED";

  const isDeliveryBlocked =
    paymentStatus && !paymentStatus.allowedActions?.canDeliver;

  const noActions =
    !canConfirm && !canProcess && !canMarkReady && !canDispatch && !canDeliver;

  if (noActions) {
    return null;
  }

  return (
    <div className="mb-6 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4">
      <p className="text-sm font-medium text-gray-700 mb-3">
        Order Status Update
      </p>
      <div className="flex flex-wrap gap-2">
        {canConfirm && (
          <Button
            variant="success"
            size="sm"
            onClick={() => onUpdateStatus("CONFIRMED")}
            className="flex items-center gap-2"
          >
            <CheckCircleIcon className="w-4 h-4" />
            Confirm Order
          </Button>
        )}

        {canProcess && (
          <Button
            variant="primary"
            size="sm"
            onClick={() => onUpdateStatus("PROCESSING")}
            className="flex items-center gap-2"
          >
            <ClockIcon className="w-4 h-4" />
            Start Processing
          </Button>
        )}

        {canMarkReady && (
          <Button
            variant="primary"
            size="sm"
            onClick={() => onUpdateStatus("READY")}
            className="flex items-center gap-2"
          >
            <CheckCircleIcon className="w-4 h-4" />
            Mark as Ready
          </Button>
        )}

        {canDispatch && (
          <>
            {isDeliveryBlocked ? (
              <div className="flex items-center gap-2 px-3 py-2 bg-red-50 border border-red-200 rounded-lg">
                <XCircleIcon className="w-4 h-4 text-red-600" />
                <span className="text-sm text-red-700">
                  Complete payment before dispatch
                </span>
                <Button size="sm" variant="primary" onClick={onUpdatePayment}>
                  Add Payment
                </Button>
              </div>
            ) : (
              <Button
                variant="primary"
                size="sm"
                onClick={() => onUpdateStatus("DISPATCHED")}
                className="flex items-center gap-2"
              >
                <TruckIcon className="w-4 h-4" />
                Dispatch Order
              </Button>
            )}
          </>
        )}

        {/* ✅ FIXED: Show "Mark as Delivered" when canDeliver but NOT canDispatch */}
        {canDeliver && !canDispatch && (
          <Button
            variant="success"
            size="sm"
            onClick={() => onUpdateStatus("DELIVERED")}
            className="flex items-center gap-2"
          >
            <CheckCircleIcon className="w-4 h-4" />
            Mark as Delivered
          </Button>
        )}
      </div>
    </div>
  );
};

export default QuickActionsBar;
